import { Instagram, Mail, Phone } from "lucide-react";
import { useTranslation } from "react-i18next";
import logo from "../../assets/restaurant/logo.png";

export default function Footer() {
	const { t } = useTranslation();

	return (
		<footer className="bg-white text-gray-600">
			<div className="max-w-6xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-3 gap-8">
				{/* Logo + claim */}
				<div>
					<img src={logo} alt="Applaby" className="h-10 mb-4" />
					<p className="text-sm">{t("beautyHero.footer.claim")}</p>
				</div>

				{/* Menú */}
				<div className="flex flex-col gap-2 text-sm">
					<a href="/" className="hover:text-primary transition">
						{t("beautyHero.footer.links.home")}
					</a>
					<a href="/salones/demo" className="hover:text-primary transition">
						{t("beautyHero.footer.links.demo")}
					</a>
					<a
						href="/salones"
						onClick={(e) => {
							e.preventDefault();
							document.querySelector("#precios")?.scrollIntoView({
								behavior: "smooth",
							});
						}}
						className="hover:text-primary transition"
					>
						{t("beautyHero.footer.links.pricing")}
					</a>
					<a
						href="https://applaby.com/terminos"
						target="_blank"
						rel="noreferrer"
						className="hover:text-primary transition"
					>
						{t("beautyHero.footer.links.terms")}
					</a>
					<a
						href="https://applaby.com/politica-privacidad"
						target="_blank"
						rel="noreferrer"
						className="hover:text-primary transition"
					>
						{t("beautyHero.footer.links.privacy")}
					</a>
				</div>

				{/* Contacto + redes */}
				<div className="flex flex-col gap-3 text-sm">
					<div className="flex flex-col gap-3 text-sm">
						<a
							href="mailto:info@applaby.com"
							className="flex items-center gap-2 hover:text-primary transition"
						>
							<Mail className="w-4 h-4" /> info@applaby.com
						</a>
						<a
							href="tel:+34608916357"
							className="flex items-center gap-2 hover:text-primary transition"
						>
							<Phone className="w-4 h-4" /> +34 608 916 357
						</a>
						<a
							href="https://www.instagram.com/applaby_es"
							target="_blank"
							rel="noreferrer"
							className="flex items-center gap-2 hover:text-primary transition"
						>
							<Instagram className="w-5 h-5" /> @applaby_es
						</a>
					</div>
				</div>
			</div>

			<div className="border-t border-gray-200 mt-10 mb-6 pt-6 text-center text-xs text-gray-500">
				© {new Date().getFullYear()} Applaby. {t("beautyHero.footer.rights")}
			</div>
		</footer>
	);
}
